module.exports = __webpack_public_path__ + "img/font-contrast.94f4ec72.svg";